import ErrorView from 'features/errors/ErrorView';

const UnhandledErrorView = () => <ErrorView code={500} description="Something went wrong, please try again later." />;

export default UnhandledErrorView;
